import React, { lazy } from 'react';
import useSideNavItems from '../hooks/useSideNavItems';

const LandingPage = lazy(() => import('@amzn/carrier-logistics-common-ui-assets/dist/App'));

const LandingPageComponent = () => {
  const sideNavItems = useSideNavItems();
  return <LandingPage config={sideNavItems.slice(1)} />;
};

export default LandingPageComponent;
